import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SfaRatingHdrContainerModel } from "../../../../../models/aggregates/sfa/SfaRatingHdrContainer.model";
import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { Core2Config } from "../shared/core2Config";

@Injectable({
	providedIn: "root",
})
export class SfaRatingHdrService extends BaseApiTemplateService<SfaRatingHdrContainerModel> {
	readonly url =
		Core2Config.TENANT_DOMAIN_URL_PREFIX +
		Core2Config.SFA_MODULE_PREFIX +
		"ratings";

	constructor(http: HttpClient) {
		super();
		this.apiUrl =
			Core2Config.DOMAIN_URL +
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.SFA_MODULE_PREFIX +
			"ratings";
		this.endpoint_path =
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.SFA_MODULE_PREFIX +
			"ratings";
		this.httpClient = http;
	}
}
